export const CONFIRM_MODAL_MAX_WIDTH = 504;
